export default __webpack_public_path__ + "static/media/data-replication-services.bf516669.svg";